<script setup lang="ts">
// Shared full-page / section loading state: a centered spinner with an optional label.
// Sibling of EmptyState/ErrorState — use it instead of hand-rolling a ProgressSpinner block.
import ProgressSpinner from 'primevue/progressspinner';

withDefaults(defineProps<{
    label?: string;
    size?: 'small' | 'large';
}>(), {
    label: 'Carregando…',
    size: 'large',
});
</script>

<template>
    <div
        class="flex flex-col items-center justify-center text-center gap-4 text-surface-500"
        :class="size === 'large' ? 'py-20 px-6' : 'py-10 px-4'"
    >
        <ProgressSpinner
            :style="size === 'large' ? { width: '3rem', height: '3rem' } : { width: '2rem', height: '2rem' }"
            stroke-width="4"
            animation-duration="1s"
        />
        <p v-if="label" :class="size === 'large' ? 'text-sm font-medium' : 'text-xs'">{{ label }}</p>
    </div>
</template>
